/// <reference path="../_references.js" />

function mStateManagerError_Init(aPrevious, aCurrent) {
    "use strict";
    var lLayout = aCurrent.Tab + '.Layout.htm';
    populateElement('uMasterContentHolder', lLayout, mStateManagerError_OnComplete);
}

function mStateManagerError_OnComplete() {
    "use strict";
}
